import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'
import { useDispatch, useSelector } from 'react-redux'
import { user } from 'ampersand-app'
import PropTypes from 'prop-types'

import lang from '@/lang'
import PageWrapper from './components/pageWrapper'
import AcceptAvvAndAgbForm from './components/acceptAvvAndAgbForm'
import { setIsSaving, resetState } from '@/redux/ducks/onboarding/main-v2'
import { toast } from '@/modules/base/components/toast/toastConfig'
import RegisterService from '@/modules/_services/register.service'
import { fetchData } from '@/redux/ducks/user/info'
import { isMeinBuero } from '@/utils/build-env'
import { reset as resetWizard } from '@/redux/ducks/wizard/config'
import GtmService, { GtmEventTypes } from '@/modules/_services/gtm.service'

const isMeinbuero = isMeinBuero()

const eventOmo = 'Avv/Agb'

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    margin: 0,
  },
}))

const OnboardingAvv = ({ onClose }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const {
    tenant: { info: { subscriptions } },
    user: { info: userInfo },
    onboarding: { mainV2: { passwordData: { password }, ...onboardingData } },
  } = useSelector(state => state)
  const isTaxConsultant = subscriptions?.some(s => s.isTaxConsultant === true)
  const subscriptionTypeTypesLabel = subscriptions?.map(s => s.typeOfSubscription).join(', ') || ''

  const { step, totalSteps } = useSelector(state => state.wizard.config)

  const [inputsValid, setInputsValid] = useState(true)

  const onButtonClick = async() => {
    GtmService.pushEvent({
      'event': GtmEventTypes.GaEventHub,
      'eventCategory': 'Onboarding',
      'eventAction': 'Weiter',
      'email': userInfo?.email || '',
      'eventLabel': `${eventOmo} abgeschlossen ${subscriptionTypeTypesLabel} (${step}/${totalSteps})`,
    })
    if (isTaxConsultant || (step === totalSteps)) {
      dispatch(setIsSaving(true))
      try {
        if (password) onboardingData.password = password
        delete onboardingData.industry
        const { body: { data: { trackingData, ...data } } } = await RegisterService.finishOnboarding(onboardingData)
        dispatch(setIsSaving(false))
        dispatch(resetState())
        dispatch(resetWizard())

        user.token = data.token
        user.store()

        onClose && onClose()

        dispatch(fetchData())
        toast.showToast({ type: 'success', message: lang.onboardingV2.general.success })
      } catch (e) {
        console.error(e)
        toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
        dispatch(setIsSaving(false))
      }
      onClose && onClose()
      return true
    }
    return true
  }

  const onButtonClickMbo = async() => {
    if (ENV.product === 'meinbuero') {
      GtmService.pushEvent({
        'event': GtmEventTypes.MboOnboarding,
        'mbo-onboarding-step': 'datenschutz-abgeschlossen',
      })
      if (onClose) {
        dispatch(setIsSaving(true))
        try {
          if (password) onboardingData.password = password
          const { body: { data: { trackingData, ...data } } } = await RegisterService.finishOnboarding(onboardingData)
          dispatch(setIsSaving(false))
          dispatch(resetState())
          dispatch(resetWizard())

          user.token = data.token
          user.store()

          GtmService.pushEvent({
            'event': GtmEventTypes.OnboardingFinished,
          })

          const temp = document.createElement('div')
          temp.innerHTML = '<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/399883343/?label=y_vZCOHozYkCEM_41r4B&amp;guid=ON&amp;script=0" />'
          temp.innerHTML += '<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/983105331/?label=-1NRCMzYme4BELP-49QD&amp;guid=ON&amp;script=0" />'
          temp.innerHTML += '<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/397450461/?label=KtqTCOyNg4oCEN25wr0B&amp;guid=ON&amp;script=0" />'
          temp.innerHTML += '<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3204225&conversionId=4067465&fmt=gif" />'
          document.body.appendChild(temp)

          onClose && onClose()

          dispatch(fetchData())
        } catch (e) {
          console.error(e)
          toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
          dispatch(setIsSaving(false))
        }

        onClose()
      }
    }
    if (isTaxConsultant) {
      onClose && onClose()
      return false
    }
    return true
  }

  const onBackButtonClick = () => {
    if (ENV.product === 'orgamax') {
      GtmService.pushEvent({
        'event': GtmEventTypes.GaEventHub,
        'eventCategory': 'Onboarding',
        'eventAction': 'Zurück',
        'eventLabel': `${eventOmo} zurück ${subscriptionTypeTypesLabel} (${step}/${totalSteps})`,
      })
    }
    return true
  }

  const avvForm = <AcceptAvvAndAgbForm setInputsValid={setInputsValid} />

  return (
    <PageWrapper
      title={lang.onboardingV2.avv.title}
      text={lang.onboardingV2.avv.text}
      isMboOnboarding={isMeinbuero}
      onNextButtonClick={isMeinbuero ? onButtonClickMbo : onButtonClick}
      onBackButtonClick={onBackButtonClick}
      disabled={!inputsValid}
      width={800}
    >
      <form className={classes.form}>
        <div>
          {avvForm}
        </div>
      </form>
    </PageWrapper>
  )
}

OnboardingAvv.propTypes = {
  onClose: PropTypes.func,
}

export default OnboardingAvv
